import React from 'react';
import { connect } from 'react-redux';

export default (initAction, Component) => {
  class Wrapper extends React.Component {
    componentWillMount() {
      const { onInit } = this.props;
      onInit();
    }

    render() {
      const { onInit, ...props } = this.props; // eslint-disable-line no-unused-vars

      return (
        <Component {...props} />
      );
    }
  }

  const mapDispatchToProps = (dispatch) => ({
    onInit: () => dispatch(initAction)
  });

  return connect(null, mapDispatchToProps)(Wrapper);
};
